import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {TinyColor} from "@ctrl/tinycolor";
import {ThemeService} from "../../_services/theme.service";

@Component({
    selector: 'app-clickable-shape',
    templateUrl: './clickable-shape.component.html',
    styleUrl: './clickable-shape.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClickableShapeComponent implements OnChanges {
    @Input({required: true}) shape!: 'balloon' | 'bomb' | 'heart'
    @Input() text: string = ''
    @Input() popText: string = ''
    @Input() clickCount: number = 1;
    @Input() color: string = '#ffe1aa';
    @Input() shadowsDisabled: boolean = false;
    @Input() textBackgroundDisabled: boolean = false;
    @Input() showReset: boolean = false;
    @Input() svgWidth: number = 100;
    @Output() pauseAnimation: EventEmitter<any> = new EventEmitter<any>();
    @Output() selectOption: EventEmitter<any> = new EventEmitter();
    @Output() clicked: EventEmitter<any> = new EventEmitter();

    colorAccent: string | null = null;
    fracturePercent: number = 0
    clickedCount: number = 0;
    popped: boolean = false;
    hideAll: boolean = false;
    readableColour: string = '#000';
    @ViewChild('balloonElement') balloonElement: ElementRef | undefined;
    @ViewChild('heartElement') heartElement: ElementRef | undefined;
    @ViewChild('bombElement') bombElement: ElementRef | undefined;

    constructor(private readonly cdr: ChangeDetectorRef,
                protected themeService: ThemeService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.readableColour = this.themeService.getReadableColor(this.color) || '#000'

        if (this.color) {
            if (!this.shadowsDisabled) {
                this.colorAccent = new TinyColor(this.color).darken(12).toHexString()
            } else {
                this.colorAccent = this.color
            }
            this.cdr.detectChanges();
        } else {
            if (!this.shadowsDisabled) {
                this.colorAccent = new TinyColor('#ffe1aa').darken(12).toHexString()
            } else {
                this.colorAccent = '#ffe1aa'
            }
            this.cdr.detectChanges();
        }
    }


    fractureShape(): void {
        this.clicked.emit();
        this.clickedCount++
        if (this.clickedCount >= this.clickCount) {
            this.pauseAnimation.emit();
            if (this.shape === 'balloon') {
                var audio = new Audio('../../../assets/audio/balloonPop.mp3');
                audio.play();
            } else if (this.shape === 'heart') {
                var audio = new Audio('../../../assets/audio/thud.m4a');
                audio.play();
            } else if (this.shape === 'bomb') {
                var audio = new Audio('../../../assets/audio/bomb.m4a');
                audio.play();
            }
            setTimeout((): void => {
                this.triggerFinishAnimation()
            }, 100);
        } else {
            this.fracturePercent = (this.clickedCount / this.clickCount) * 100;
            if (this.shape === 'balloon') {
                var audio = new Audio('../../../assets/audio/thud.m4a');
                audio.play();
            } else if (this.shape === 'heart') {
                var audio = new Audio('../../../assets/audio/thud.m4a');
                audio.play();
            } else if (this.shape === 'bomb') {
                var audio = new Audio('../../../assets/audio/fireCrackle.m4a');
                audio.play();
            }
        }
    }

    triggerFinishAnimation(): void {
        this.popped = true;
        this.cdr.detectChanges();
        if (this.shape === 'balloon') {
            setTimeout((): void => {
                this.selectOption.emit()
                this.hideAll = true;
            }, 300);
        } else {
            setTimeout((): void => {
                this.selectOption.emit()
                this.hideAll = true;
            }, 1000);
        }
    }

    reset(): void {
        this.hideAll = false
        this.popped = false
        this.clickedCount = 0;
        this.fracturePercent = 0;
    }

    bombViewBox(): number {
        if (this.fracturePercent >= 80) {
            return 733.92
        } else if (this.fracturePercent > 40) {
            return 801.13
        } else if (this.fracturePercent > 0) {
            return 907.1
        } else {
            return 936.56
        }
    }

    calculateFontSize(x: number): number {
        const x1: number = 66;
        const y1: number = 10;
        const x2: number = 170;
        const y2: number = 16;

        // mad AI function to get the font I want
        // to Calculate the slope (m)
        const m: number = (y2 - y1) / (x2 - x1);

        // Calculate the y-intercept (c)
        // Using the formula: c = y1 - m * x1
        const c: number = y1 - m * x1;

        // Calculate y using the linear equation
        const y: number = m * x + c;

        return y;
    }
}
